import React from 'react'
import { useSelector } from 'react-redux'
import styles from './Footer.module.css'
import { Link } from 'react-router-dom'
import packageJson from '../../../package.json'
import appStoreBtn from '../../assets/btn-app-store.svg'
import ggPlayBtn from '../../assets/btn-gg-play.svg'
import icFb from '../../assets/ic-facebook.svg'
import icInsta from '../../assets/ic-insta.svg'
import { appURL, social } from '../../constants'

const Footer = () => {
  const token = useSelector(state => state.auth.token)
  return (
    <div className={styles['footer-wrapper']}>
      <div className={styles.footerContent}>
        <div className={styles['footer']}>
          <ul>
            <li className={styles['head']}>Download Our Apps</li>
            <li>
              <Link to={appURL.APP_STORE} target='_blank'>
                <img alt='app-store-button' src={appStoreBtn} />
              </Link>
            </li>
            <li>
              <Link to={appURL.GOOGLE_PLAY} target='_blank'>
                <img alt='google-play-button' src={ggPlayBtn} />
              </Link>
            </li>
          </ul>

          {token && (
            <ul>
              <li className={styles['head']}>Subscribe</li>
              <li>
                <Link to='/subscription'>View Packages</Link>
              </li>
            </ul>
          )}

          <ul>
            <li className={styles['head']}>Contact Us</li>
            <li>
              <a href={`mailto:${social.SUSHIROLL_EMAIL}`} target='_top'>
                {social.SUSHIROLL_EMAIL}
              </a>
            </li>
            <li className={styles.iconsWrapper}>
              <a
                rel='noopener noreferrer'
                target='_blank'
                href={social.SUSHIROLL_FACEBOOK}
              >
                <img src={icFb} alt='icon-facebook' />
              </a>
              <a
                rel='noopener noreferrer'
                target='_blank'
                href={social.SUSHIROLL_INSTAGRAM}
              >
                <img src={icInsta} alt='icon-instagram' />
              </a>
            </li>
          </ul>

          <ul>
            <li className={styles['head']}>More</li>
            <li>
              <Link to='/about-us'>About Us</Link>
            </li>
            <li>
              <Link to='/terms'>Terms and Conditions</Link>
            </li>
            <li>
              <Link to='/privacy-policy'>Privacy Policy</Link>
            </li>
            <li>
              <Link to='/faqs'>FAQs</Link>
            </li>
          </ul>
        </div>

        <div
          className={styles['version']}
        >{`Application Version ${packageJson.version}`}</div>
      </div>
    </div>
  )
}

export default Footer
